module.exports = __webpack_public_path__ + "static/mack_hero-1efff2a770f14d1752c6e0590567a53f.png";